import React from "react";
import { RCCProgress } from "react-common-components";
import Container from "./styles";
import { IComponentCardMyBusinessGroup } from "./interface";

const Card = ({
	totalQuantity,
	title,
	text,
	quantity,
	colorProp,
	showQuantityZero = false
}: IComponentCardMyBusinessGroup ) => {
	const getColor = (amount: number) => {
		if(amount > 1)
			return "red";
		if(amount <= 1 && amount > 0.75)
			return "yellow";
		return "green";
	};
	const amount = totalQuantity > 0 ? quantity/totalQuantity : 0;
	const color = colorProp ?? getColor(amount);
	return(
		<Container color={color}>
			<span title={title}>{title}</span>
			{text && (
				<small title={text}>{text}</small>
			)}
				
			{totalQuantity > 0 ? 
				<h2>
					{quantity} / {totalQuantity}
				</h2>: 
				(showQuantityZero || quantity > 0) && <h2>{quantity}</h2>
			}
			{totalQuantity > 0 && (
				<RCCProgress 
					value={Number((amount * 100).toFixed(2))} 
					layout="line"
					color={`var(--${color})`}
				/>
			)}
		</Container>
	);};

export default Card;
